import { render, staticRenderFns } from "./MTDform.vue?vue&type=template&id=ff6e39d0&scoped=true&"
import script from "./MTDform.vue?vue&type=script&lang=js&"
export * from "./MTDform.vue?vue&type=script&lang=js&"
import style0 from "./MTDform.vue?vue&type=style&index=0&id=ff6e39d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6e39d0",
  null
  
)

export default component.exports